import moment from '@/utils/moment-wrapper';
import { http } from '@pendo/http';
import { getStarReplay } from '@/stores/api/session-replay.api';
import { buildReplayRecordingRouteObject } from '@/session-replay/helpers/common.util';

export const BULK_NOTIFICATION_TYPES = ['bulkUserDelete', 'bulkUserPermissionUpdate'];

export function isBulkNotification (notification) {
    return BULK_NOTIFICATION_TYPES.includes(notification?.type);
}

export function formatTimestamp (timestamp) {
    return moment(timestamp).fromNow();
}

export function groupByDateRange (objectsArray) {
    const now = Date.now();

    // Calculate the timestamp for exactly 7 days ago (in milliseconds).
    // 7 (days) * 24 (hours in a day) * 60 (minutes in an hour) * 60 (seconds in a minute) * 1000 (milliseconds in a second).
    const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000;

    const grouped = {
        last7Days: [],
        olderThan7Days: [],
    };

    objectsArray.forEach((obj) => {
        if (obj.timestamp >= sevenDaysAgo) {
            grouped.last7Days.push(obj);
        } else {
            grouped.olderThan7Days.push(obj);
        }
    });

    return grouped;
}

export async function markAllInAppNotificationsAsRead () {
    await http.post('/api/s/_SID_/in-app-notification/mark-all-read');
}

export async function markInAppNotificationAsRead (notificationId) {
    await http.put(`/api/s/_SID_/in-app-notification/${notificationId}/read`, { read: true });
}

export async function subscribeToThread (threadId) {
    await http.post(`/api/s/_SID_/in-app-commenting/thread/${threadId}/subscribe`);
}

export async function unsubscribeFromThread (threadId) {
    await http.delete(`/api/s/_SID_/in-app-commenting/thread/${threadId}/subscribe`);
}

export function getReplayRecordId (notification) {
    return notification?.notification?.threadEntities?.replay?.[0];
}

// threadEntities.replay holds the replay record id, not the recording session id the route needs.
// Callers rely on buildReplayRecordingRouteObject returning undefined (not throwing) when the
// recording session id is missing, and treat an undefined result as "replay unavailable".
export async function getReplayCommentRouteObject ({ replayRecordId, threadId }) {
    const replayContext = await getStarReplay(replayRecordId);

    return buildReplayRecordingRouteObject({ replayContext, additionalQueryParams: { threadId } });
}
